export default "__VITE_ASSET__d54b381b__"